import FooterWave2Icon from "@/public/site-assets/svg/footer-wave-2.svg";
import clsx from "classnames";
import { Container } from "reactstrap";
import { Buttons } from "ui/Buttons";
import styles from "./styles.module.scss";
import OverlayDots from "/public/site-assets/svg/overlay-dots.svg";
import TimelineBorder from "/public/site-assets/svg/timeline-border.svg";

export const DualColumnTimelineCTA = ({
  className,
  bgColor,
  left_heading,
  left_subtitle,
  left_content,
  left_buttons,
  left_image,
  right_heading,
  right_subtitle,
  right_content,
  right_buttons,
  right_image,
  text_align = "center",
  heading,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  return (
    <>
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <section className={clsx(className, bgColor, styles.root)}>
        <Container>
          {heading && (
            <div>
              <h4 className={`header-heading mb-4`}>{heading}</h4>
            </div>
          )}
          <div className={`d-flex flex-lg-nowrap flex-wrap text-${text_align} wrapper`}>
            <div
              className={`column position-relative ${text_align == "center" ? "justify-content-center" : ""} flex-wrap d-flex`}
            >
              <div>
                {left_image && (
                  <div>
                    <span className="overlay-dots position-absolute">
                      <OverlayDots />
                    </span>
                    <img
                      className={`mb-4 position-relative`}
                      src={left_image?.url}
                      alt={left_image?.alt}
                      width={500}
                    />
                  </div>
                )}
                <div className="d-flex gap-2 flex-wrap">
                  <h3 className={`heading w-100`}>{left_heading}</h3>
                  <h5 className={`subtitle w-100`}>{left_subtitle}</h5>
                  <div
                    className={`content w-100`}
                    dangerouslySetInnerHTML={{ __html: left_content }}
                  />
                </div>
              </div>
              <div className="d-flex align-items-end">
                {left_buttons && (
                  <Buttons
                    buttons={left_buttons}
                    className="d-flex align-items-center text-center"
                  />
                )}
              </div>
            </div>
            <div className="d-none d-lg-block timeline-border">
              <TimelineBorder />
            </div>
            <div
              className={`column position-relative justify-content-${text_align} flex-wrap d-flex`}
            >
              <div>
                {right_image && (
                  <div>
                    <span className="overlay-dots position-absolute">
                      <OverlayDots />
                    </span>
                    <img
                      className={`mb-4 position-relative`}
                      src={right_image?.url}
                      alt={right_image?.alt}
                      width={500}
                    />
                  </div>
                )}
                <div className="d-flex gap-2 flex-wrap">
                  <h3 className={`heading w-100`}>{right_heading}</h3>
                  <h5 className={`subtitle w-100`}>{right_subtitle}</h5>
                  <div
                    className={`content w-100`}
                    dangerouslySetInnerHTML={{ __html: right_content }}
                  />
                </div>
              </div>
              <div className="d-flex align-items-end">
                {right_buttons && (
                  <Buttons
                    buttons={right_buttons}
                    className="d-flex align-items-center text-center"
                  />
                )}
              </div>
            </div>
          </div>
        </Container>
      </section>
      {showWave && (
        <div
          className={clsx(
            "footer",
            waveDirection === "down" && "rotate",
            waveColor,
            waveBackground,
          )}
          style={{ marginTop: "-1px" }}
        >
          <FooterWave2Icon />
        </div>
      )}
    </>
  );
};

export default DualColumnTimelineCTA;
